import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApartmentOneComponent } from './apartment-one.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { Angular2ImageGalleryModule } from 'angular2-image-gallery/app/angular2imagegallery.module';
import { ImgHeaderModule } from '../../img-header/img-header.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    Angular2ImageGalleryModule,
    ImgHeaderModule
  ],
  declarations: [
    ApartmentOneComponent
  ],
  exports: [
    ApartmentOneComponent
  ]
})
export class ApartmentOneModule { }



// WEBPACK FOOTER //
// ./src/app/pages/apartment-one/apartment-one.module.ts